var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ci-form"},[_c('BaseInput',{staticClass:"ci-form__input",attrs:{"value":_vm.value,"readonly":""}}),_c('BaseButton',{staticClass:"ci-form__btn",attrs:{"type":"button","disabled":!_vm.value},on:{"click":_vm.handleCopy}},[_c('DoneText',{attrs:{"text":_vm.textAfter,"done":_vm.isСopied}},[_vm._v(_vm._s(_vm.textBefore))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }